import axios from "axios";
import { authService } from "./authService";
import store from "../app/store";
import { startLoading, stopLoading } from "../features/ui/uiSlice";
import json from "../secret.json";

const API_BASE_URL = json.API_BASE_URL;

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Refresh 요청용 인스턴스 (Interceptor 돌기 전 순수 인스턴스)
const refreshInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 요청 인터셉터
instance.interceptors.request.use(
  (config) => {
    // withAuth 옵션이 true인 경우에만 Authorization 헤더에 토큰 주입
    if (config.withAuth) {
      const token = authService.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    store.dispatch(startLoading());
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());

    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 401 발생 시 Refresh Token 로직
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest.withAuth &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refreshToken = authService.getRefreshToken();
      if (refreshToken) {
        try {
          const refreshResponse = await refreshInstance.post(
            "/api/v1/token/refresh",
            {
              refresh: refreshToken,
            }
          );

          const { access, refresh } = refreshResponse.data;
          authService.setTokens(access, refresh);

          originalRequest.headers["Authorization"] = `Bearer ${access}`;
          const finalResponse = await instance(originalRequest);
          store.dispatch(stopLoading());

          return finalResponse;
        } catch (refreshError) {
          authService.removeTokens();
          store.dispatch(stopLoading());

          alert("로그인이 만료되었습니다. 다시 로그인해주세요.");
          window.location.href = "/login";

          return Promise.reject(refreshError);
        }
      } else {
        alert("로그인이 만료되었습니다. 다시 로그인해주세요.");
        window.location.href = "/login";

        return Promise.reject(error);
      }
    }
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

const apiClient = {
  async get(endpoint, config = {}) {
    const response = await instance.get(endpoint, config);
    return response;
  },

  async post(endpoint, data, config = {}) {
    const response = await instance.post(endpoint, data, config);
    return response;
  },

  async put(endpoint, data, config = {}) {
    const response = await instance.put(endpoint, data, config);
    return response;
  },

  async delete(endpoint, config = {}) {
    const response = await instance.delete(endpoint, config);
    return response;
  },

  // put, delete 등 필요 시 추가
};

export default apiClient;
